export default __webpack_public_path__ + "static/media/Engel-auf-Wolke.bf6aa654.png";